import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
class LogoutComponent extends BridgeComponent {
    static component = "logout";
    connect() {
        const element = this.bridgeElement;
        const logoutlink  = element.bridgeAttribute("logoutlink");
        const data = { logoutlink: logoutlink };

        this.send("connect", data, (response) => {
            window.location.href = response?.logoutlink;
        });
    }

    disconnect() {
        this.send("disconnect");
    }
}

export default LogoutComponent;